var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #1d7b91;\n      }\n\n      .st2 {\n        fill: #00d6de;\n      }\n\n      .st3 {\n        fill: #fff;\n      }\n\n      .st4 {\n        fill: #b3ffff;\n      }\n\n      .st5 {\n        fill: #d1e8e7;\n      }\n\n      .st6 {\n        clip-path: url(#graphics-clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "graphics-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 27.4,
    y: 47,
    width: 137.2,
    height: 118
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_255",
    className: "st3",
    d: "M20,46.8C-3.9,72.6-2.6,113.1,5.1,130.7c9.5,21.8,29,35.5,42.5,42.5,32.5,16.8,96.5,32.5,129.7-.6,47.5-47.2-25.7-267.4-157.3-125.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_183"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2551",
    "data-name": "Trac\\xE9_255",
    className: "st5",
    d: "M50.8,80.1c-12.6,13.5-11.9,34.8-7.8,44,5,11.5,15.2,18.7,22.3,22.3,17.1,8.8,50.7,17.1,68.1-.3,24.9-24.8-13.5-140.4-82.6-66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_256",
    className: "st4",
    d: "M41.7,60.3c-2.5.2-4.7,1.6-5.9,3.9-.6,1.6-.6,3.3-.1,5,.8,2.9,3.6,7.6,7.4,7.8,5.5.2,14.6-16.8-1.4-16.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_257",
    className: "st1",
    d: "M98,91.5c2.2-9.8,11.4-20.5,21.2-18.3l35.3,5c9.8,2.2,11.4,13.7,9.3,23.5-2.2,9.8-11.9,16-21.7,13.8,0,0,0,0,0,0l-24.6-5.5c-3.1,2.2-6.5,4-10.1,5.5-.4.2-.8,0-.9-.4-.1-.3,0-.6.2-.8,1.2-.9,2.2-2.1,3-3.3.5-.8.8-1.6,1.1-2.4-9.4-2.4-14.8-7.4-12.7-17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_258",
    className: "st3",
    d: "M124.1,99.3l-6.1-5.3v1.6s5.9-5.6,5.9-5.6c1.1-1-.7-2.6-1.8-1.5l-5.8,5.6c-.4.4-.4,1,0,1.5,0,0,0,0,0,0l6.1,5.3c1.1,1,2.8-.6,1.7-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_259",
    className: "st3",
    d: "M139.8,89.7l6.1,5.3v-1.6s-5.9,5.6-5.9,5.6c-1.1,1,.7,2.6,1.8,1.5l5.8-5.6c.4-.4.4-1,0-1.5,0,0,0,0,0,0l-6.1-5.3c-1.1-1-2.8.6-1.7,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_260",
    className: "st3",
    d: "M129,104l8-17.9c.6-1.3-1.6-2.4-2.2-1.1l-8,17.9c-.6,1.3,1.6,2.4,2.2,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_261",
    className: "st2",
    d: "M27.7,108.8l18,8.7,3,16.2,18.2,9.5,3.2,21.7-38.1-20.5-4.2-35.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_262",
    className: "st1",
    d: "M91.8,97.9l-15.2,13.8,2.8,18-12.4,11.7,4.3,22.4,27-26.2-6.5-39.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_263",
    className: "st2",
    d: "M91.4,98c-12-4.7-23.8-9.1-35.4-13.6l.9-.2-27.1,25.1-.4-2.3c11.5,4.4,22.7,9.3,33.9,14.4l-1.8.3c9.3-7.8,20.3-16,29.9-23.6M91.8,97.9c-8.3,7.9-19.4,18.8-28,26.3-.5.4-1.2.6-1.8.3-11.3-4.7-22.6-9.6-33.6-15-.7-.3-1-1.1-.7-1.8,0-.2.2-.3.3-.5,0,0,27.8-24.3,27.8-24.3.2-.2.6-.3.9-.1,11.9,5.1,23.6,10.3,35.1,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_264",
    className: "st2",
    d: "M91.7,100c.9,12.6,2.5,25.2,4.6,37.7l.5-1.6c-7.9,7.8-19.3,19.2-27.3,27.2l1.7.6c-2.4-12.5-4.5-25.5-7.3-37.7,1.3,12.5,3.5,25.4,5.2,38.1,0,.6.6.9,1.2.9.2,0,.4-.1.5-.3l14.2-13.1c4.7-4.3,9.5-8.6,14.2-13,.4-.4.6-1,.5-1.5-1.5-9.4-3.3-18.7-5.5-28-.7-3.1-1.5-6.2-2.3-9.2,0,0-.1-.1-.2-.1,0,0-.1,0-.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_265",
    className: "st3",
    d: "M27.5,108.4c-.1,10.8,0,24.9,1.9,35.5,0,.5.4.9.8,1.2,6.2,3.2,22.2,11.3,28.3,14.3l9.5,4.7c.2,0,.4-.2.2-.3l-9.1-5.4c-5.7-3.4-21.4-12.6-27.3-16.1l.8,1.2c-.9-10.7-1.7-24.8-4.6-35.1,0,0-.1-.1-.2-.1,0,0-.1,0-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_266",
    className: "st2",
    d: "M76.6,111.7c-1.4-.6-1.6.6-3,.2-4.1-1.1-9.3-3.3-13.4-4.9h.4c0,0-13.1,10.1-13.1,10.1l-.2-1.1c5.4,2.1,10.7,4.4,16,6.8h-.9c4.4-3.6,9.6-7.4,14.1-11M76.7,111.7c-3.9,3.7-9.2,8.9-13.2,12.4-.2.2-.6.3-.9.1-5.4-2.2-10.7-4.5-15.9-7.1-.3-.1-.5-.5-.3-.9,0,0,0-.2.2-.2,0,0,13.1-11.5,13.1-11.5.1-.1.3-.1.4,0,4.3,1.8,8.4,3.7,12.6,5.5,1.3.6,2.7,1.1,4,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_267",
    className: "st2",
    d: "M76.9,112.6c.4,6,1.2,11.9,2.2,17.8l.2-.7c-3.7,3.7-9.1,9.1-12.9,12.8l.8.3c-1.1-5.9-2.6-14.2-3.9-20,.2,2-1.4-.7-1.1,1.3.5,4,2.8,14.8,3.3,18.7,0,.4,1.3.7,1.6.4l6.7-6.2c2.2-2.1,4.5-4.1,6.7-6.2.2-.2.3-.5.3-.7-.7-4.4-1.6-8.8-2.6-13.2-.3-1.5-.7-2.9-1.1-4.4,0,0,0,0-.1,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_268",
    className: "st3",
    d: "M45.9,118.3c0,5.1.4,10.1,1.3,15.1,0,.2.2.4.4.5,2.9,1.5,10.5,5.4,13.3,6.8l4.5,2.2c0,0,.2,0,0-.1-.2-.8-.8-1.6-1.5-2-.9-.6-12.9-6.4-15.7-8.1l.4.5c-.4-5-1.3-10-2.6-14.9,0,0,0,0-.1,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_269",
    className: "st3",
    d: "M73.5,111.9l-13.4-4.9-10.5,8.3,12.8,5.6,11.1-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_270",
    className: "st3",
    d: "M96.8,58l-13.6-8.7-14.6,4.8,12.8,10.9,15.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_271",
    className: "st2",
    d: "M96.8,58c-1.1-.9-1.6,0-2.8-.7-3.4-2.2-7.6-5.5-10.8-8.1h.4s-14.6,5.7-14.6,5.7v-1c4.5,3.3,8.7,6.9,12.8,10.5h-.8c3.6-1.7,9.9-5.6,13.8-7.1.8-.4,1.7,0,2.1.7M96.7,58.2c-4.6,2.3-10.4,5.5-15.1,7.6-.3.1-.6,0-.8-.1-4.2-3.5-8.4-7-12.5-10.7-.3-.2-.3-.6,0-.9,0,0,.1-.1.2-.2,0,0,15-6.9,15-6.9.1,0,.3,0,.4,0,3.4,2.8,6.7,5.6,9.9,8.3,1.1.9,2.2,1.7,3.2,2.5l-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_272",
    className: "st2",
    d: "M96.8,58.2c-1.2,5.5-2.1,11.8-2.8,17.4l.4-.6c-4.4,2.3-10.7,5.8-15.2,8.1l.7.5c.6-5.7,1.5-13.6,1.8-19.2-.3,1.8-1.1-1-1.4.9-.6,3.8-1.5,14.1-2,17.9,0,.4,1,1,1.3.8l7.7-3.8c2.6-1.3,5.2-2.5,7.7-3.8.2-.1.4-.3.4-.6.6-4.2,1-8.4,1.2-12.7,0-1.4,0-3.6.1-5,0,0-.2,0-.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_273",
    className: "st3",
    d: "M67.3,55.7c-1.4,4.6-2.4,9.3-2.9,14,0,.2,0,.4.2.6,2.3,2.2,8.1,7.7,10.3,9.7l3.4,3.2c0,0,.2,0,.1-.1,0-.8-.3-1.6-.8-2.3-.7-.8-9.9-9.3-12-11.6l.2.6c1-4.7,1.6-9.4,1.7-14.2,0,0,0,0,0,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_274",
    className: "st2",
    d: "M81.3,65.1l15.7-7.1-1.8,18.5-15.9,6.7,2-18.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphics);
export default __webpack_public_path__ + "static/media/graphics.2200648ff26fddd8f5120613bebfd936.svg";
export { ForwardRef as ReactComponent };